"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@fluentui/react");
var react_2 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
require("./NoRecordPanel.scss");
exports.NoRecordPanel = function (props) {
    var _a, _b;
    var url = props.url, showFrequentlyUsedLink = props.showFrequentlyUsedLink, onShowFrequentlyUsedLink = props.onShowFrequentlyUsedLink, showCannotFindPanel = props.showCannotFindPanel;
    var t = react_i18next_1.useTranslation('SearchComboBox').t;
    return (react_2.default.createElement("div", { className: 'noRecordPanel' },
        react_2.default.createElement("span", { className: 'title' }, t('NoResult')),
        showCannotFindPanel && (react_2.default.createElement(react_2.default.Fragment, null,
            react_2.default.createElement("span", { className: 'subtitle bold' }, t('CannotFind')),
            react_2.default.createElement("p", null,
                react_2.default.createElement("span", { className: 'subtitle' }, t('CannotFindSubText')),
                (url !== null && url !== void 0 ? url : '') !== '' && (react_2.default.createElement(react_2.default.Fragment, null,
                    react_2.default.createElement("span", { className: 'subtitle' }, t('LinkText')),
                    react_2.default.createElement("a", { className: 'codeURL', href: url !== null && url !== void 0 ? url : '#', rel: "noopener noreferrer", target: '_blank' }, (_a = t('ToDeclareCodeUsage')) !== null && _a !== void 0 ? _a : '')))))),
        showFrequentlyUsedLink && (react_2.default.createElement(react_1.ActionButton, { className: 'actionButtonLink', onClick: function () {
                if (onShowFrequentlyUsedLink) {
                    onShowFrequentlyUsedLink();
                }
            } }, (_b = t('SeeFrequentlyUsed')) !== null && _b !== void 0 ? _b : ''))));
};
//# sourceMappingURL=NoRecordPanel.js.map